import { render, staticRenderFns } from "./period-widget.vue?vue&type=template&id=2f7e8b1d&scoped=true&"
import script from "./period-widget.vue?vue&type=script&lang=js&"
export * from "./period-widget.vue?vue&type=script&lang=js&"
import style0 from "./period-widget.vue?vue&type=style&index=0&id=2f7e8b1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7e8b1d",
  null
  
)

export default component.exports